import { useDeviceType } from "../../hooks/useDeviceType";
import {
  AccommodationDisabledIcon,
  AccommodationIcon,
  SelectedIcon,
} from "../../styles/accommodationStyle";
import { CursorPointer, TitleZIndex } from "../../styles/theme";
import { AccommodationType } from "../../system/types/Accommodation";
import AccommodationIconList from "./AccommodationIconList";

interface AdminTitleProps {
  data: AccommodationType[];
  resourceId: number;
  selectAccomodation: (id: number) => void;
  selectedResourceId?: number;
}

function SelectAccommodationBox({
  data,
  resourceId,
  selectAccomodation,
  selectedResourceId,
}: AdminTitleProps) {
  const deviceType = useDeviceType();
  return (
    <>
      {selectedResourceId ? (
        <>
          {data.map((item, idx) => {
            return (
              <TitleZIndex key={idx}>
                {resourceId === item.id && resourceId === selectedResourceId ? (
                  <SelectedIcon onClick={() => selectAccomodation(item.id)}>
                    <div>
                      <AccommodationIconList
                        name={item.icon}
                        deviceType={deviceType}
                      />
                    </div>
                    <div>{item.name}</div>
                  </SelectedIcon>
                ) : (
                  <AccommodationDisabledIcon>
                    <div>
                      <AccommodationIconList
                        name={item.icon}
                        deviceType={deviceType}
                      />
                    </div>
                    <div
                      style={{
                        marginTop: "6px", // 아이콘과 텍스트 간격
                        textAlign: "center",
                        height: "40px", // 고정 높이
                        lineHeight: "16px", // ✅ 줄 높이 고정
                        fontSize: "14px",
                        display: "block",
                      }}
                    >
                      <div style={{ height: "16px", overflow: "hidden" }}>
                        {item.name.replace(/\s*\(.*?\)/, "")}
                      </div>
                      <div
                        style={{
                          height: "16px", // ✅ 한 줄 높이 확보 (없으면 아래가 밀림)
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.name.match(/\(.*?\)/)?.[0]}
                      </div>
                    </div>
                  </AccommodationDisabledIcon>
                )}
              </TitleZIndex>
            );
          })}
        </>
      ) : (
        <>
          {data.map((item, idx) => {
            return (
              <CursorPointer
                key={idx}
                onClick={() => selectAccomodation(item.id)}
              >
                {resourceId === item.id ? (
                  <SelectedIcon>
                    <div>
                      <AccommodationIconList
                        name={item.icon}
                        deviceType={deviceType}
                      />
                    </div>
                    <div
                      style={{
                        marginTop: "6px", // 아이콘과 텍스트 간격
                        textAlign: "center",
                        height: "40px", // 고정 높이
                        lineHeight: "16px", // ✅ 줄 높이 고정
                        fontSize: "14px",
                        display: "block",
                      }}
                    >
                      <div style={{ height: "16px", overflow: "hidden" }}>
                        {item.name.replace(/\s*\(.*?\)/, "")}
                      </div>
                      <div
                        style={{
                          height: "16px", // ✅ 한 줄 높이 확보 (없으면 아래가 밀림)
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.name.match(/\(.*?\)/)?.[0]}
                      </div>
                    </div>
                  </SelectedIcon>
                ) : (
                  <AccommodationIcon>
                    <div>
                      <AccommodationIconList
                        name={item.icon}
                        deviceType={deviceType}
                      />
                    </div>
                    <div
                      style={{
                        marginTop: "6px", // 아이콘과 텍스트 간격
                        textAlign: "center",
                        height: "40px", // 고정 높이
                        lineHeight: "16px", // ✅ 줄 높이 고정
                        fontSize: "14px",
                        display: "block",
                      }}
                    >
                      <div style={{ height: "16px", overflow: "hidden" }}>
                        {item.name.replace(/\s*\(.*?\)/, "")}
                      </div>
                      <div
                        style={{
                          height: "16px", // ✅ 한 줄 높이 확보 (없으면 아래가 밀림)
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.name.match(/\(.*?\)/)?.[0]}
                      </div>
                    </div>
                  </AccommodationIcon>
                )}
              </CursorPointer>
            );
          })}
        </>
      )}
    </>
  );
}

export default SelectAccommodationBox;
